module.exports = __webpack_public_path__ + "96bf98fefa4e12ab7e8bfbcb910ab9b6.js";